import useApi from '@components/Hooks/useApi';
import useGlobalState from '@components/Hooks/useGlobalState';
import { IEvent } from '@src/interfaces';
import Classify from '@utils/Classify';
import React, { useState } from 'react';
import { Button, Form } from 'react-bootstrap';
import Cookies from 'universal-cookie';

const cookies = new Cookies();

const LoginForm: React.FC = () => {

  const [, dispatch] = useGlobalState();
  const api = useApi(dispatch);
  const [username, setUsername] = useState<string>(cookies.get('oasis_username' + api.getSubDomain()));
  const [password, setPassword] = useState<string>('');
  const [saving, setSaving] = useState<boolean>(false);

  const hasSession = () => {
    return cookies.get('oasis_session' + api.getSubDomain()) && cookies.get('oasis_userid' + api.getSubDomain());
  }

  const login = (e: any) => {
    e.preventDefault();
    api.login(username, password).then(() => {
      setSaving(false);
    });
    setSaving(true);
    return false;
  }

  const isLoading = () => {
    return saving || api.isReallyLoading('login') || api.isReallyLoading('getSession') || hasSession();
  }

  return (
    <div className={Classify.addClassName(isLoading(), 'loading')}>
      <form
        method="post"
        id='login-form'
        action='#/blank'
        target='login-frame'
        onSubmit={login}
      >
        <div style={{ marginTop: -5 }}>
          <Form.Group controlId='username' className='form-group'>
            <Form.Label>Username (Email)</Form.Label>
            <Form.Control
              // autoFocus={!username}
              type="text"
              name='username'
              value={username || ''}
              disabled={isLoading()}
              onChange={(e: IEvent) => {
                setUsername(e.currentTarget.value);
              }}
            />
          </Form.Group>
          <Form.Group controlId='password' className='form-group'>
            <Form.Label>Password</Form.Label>
            <Form.Control
              // autoFocus={!!username}
              type="password"
              name='password'
              value={password}
              disabled={isLoading()}
              onChange={(e: IEvent) => {
                setPassword(e.currentTarget.value);
              }}
            />
          </Form.Group>
          <Form.Group style={{ marginTop: 19 }} className='form-group'>
            <a style={{ float: 'right', display: 'inline-block', padding: '6px 0', color: '#fff' }} href="#/forgot-password">Forgot Password?</a>
            <Button type="submit" id='login-button' disabled={isLoading()}>Login</Button>
          </Form.Group>
        </div>
      </form>
      <iframe name='login-frame' style={{ display: 'none' }} title="Login"></iframe>
    </div>
  );
}

export default LoginForm;